import * as React from 'react';
import { ContentType } from '../SectionWrapper/SectionWrapper';
import S from './HighlightTitle.styles';
const HighlightTitle = (props) => {
    function highlightWord(text) {
        return text.replace(/\*(.*?)\*/g, '<span>$1</span>');
    }
    return (React.createElement(S.Title, { as: props.tagType ?? 'h2', "data-text": props.theme, "data-type": props.contentType ?? ContentType.Default, dangerouslySetInnerHTML: { __html: highlightWord(props.title) } }));
};
export default HighlightTitle;
